module.exports = __webpack_public_path__ + "img/hindbaer_cheesecake_zoom.cbbf5973.jpg";